// src/firebase.js
// ================================================================
// Firebase Configuration for District Sourcing Tech
// Replace the config values below with your Firebase project config
// ================================================================
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBYDQCL93QWX3ZuJuQmXR-8Mc_Dj5YUlaY",
  authDomain: "district-sourcing-c62bf.firebaseapp.com",
  projectId: "district-sourcing-c62bf",
  storageBucket: "district-sourcing-c62bf.firebasestorage.app",
  messagingSenderId: "993255803576",
  appId: "1:993255803576:web:8c68f623f0041e9c4ec24d",
  measurementId: "G-PHXEK15KMZ"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export default app;
